import React from 'react';
import { Component } from '../../../index';
import Container from '../../layout/container/Container';
import { DASHBOARD_TITLE_PROPS, DASHBOARD_TITLE_STATE } from './Types';

class DashboardTitle extends Component<DASHBOARD_TITLE_PROPS, DASHBOARD_TITLE_STATE> {
    moduleName = 'DashboardTitle'

    state: DASHBOARD_TITLE_STATE = {
      totalItems: undefined,
      totalSubitems: undefined
    }

    /**
     * Dashboard title total items setter
     * @param totalItems
     * @param totalSubitems
     */
    setTotalItems = (totalItems?: number, totalSubitems?: number) => {
      this.setState({
        totalItems,
        totalSubitems
      });
    }

    /**
     * Render for subtitle subitems
     */
    getSubtitleSubitems = (): string => {
      const { subtitle } = this.props;
      const { totalSubitems } = this.state;
      if (typeof totalSubitems === 'number' && subtitle) {
        return ` | ${totalSubitems} ${subtitle.subitems}`;
      }
      return '';
    }

    /**
     * Render for subtitle items
     */
    getSubtitle = (): JSX.Element => {
      const { totalItems } = this.state;
      const { subtitle } = this.props;
      if (typeof totalItems === 'number' && subtitle) {
        return (
          <span
            key="totalItems"
            className="tp-page-title-total-items"
          >
            {`${totalItems} ${subtitle.items}`}
            {this.getSubtitleSubitems()}
          </span>
        );
      }
      return null;
    }

    render() {
      const { title = '' } = this.props;
      return (
        <Container
          displayFlex
          alignItemsBaseLine
          className={'tp-page-title'}
          gap={2}
          htmlTag={'h2'}
        >
          {title}
          {this.getSubtitle()}
        </Container>
      );
    }
}

export default DashboardTitle;
